import * as React from 'react';
import QuarterlyReport from 'src/entities/QuarterlyReport';

interface Props {
  quarterlyReport: QuarterlyReport;
  image: File;

  download(): void;
}

const QuarterlyReportMiniatureComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div>
    <p>
      <strong>
        Informe Quarter {props.quarterlyReport.quarter} del año {props.quarterlyReport.year}
      </strong>
    </p>
    <p className="text-center">
      <img
        style={{height: '169px'}}
        src={
          props.image ?
            // tslint:disable-next-line:no-any
            (window.URL || (window as any).webkitURL).createObjectURL(props.image) :
            '/img/docs.png'
        }
        alt={props.quarterlyReport.year + ' ' + props.quarterlyReport.quarter}
      />
    </p>
    <div
      className="grey-area text-center pointer"
      style={{
        height: '50px',
        padding: '0'
      }}
      onClick={props.download}
    >
      <img
        width=""
        alt="graphic"
        src="/img/graphic-doc.png"
      />
      <p>
        Descargar Informe
      </p>
    </div>
  </div>
);

export default QuarterlyReportMiniatureComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/quarterly-reports/QuarterlyReportMiniature.component.tsx